import analytics from "./Segment";

const { version } = require("../../package.json");

const context = {
  app: {
    version
  }
};

export const identifyUser = (uid) => {
  analytics.identify(uid);
};

export const messageSent = (message, bot, examplePrompt) => {
  analytics.track(
    "Message Sent",
    {
      bot,
      message,
      examplePrompt
    },
    { context }
  );
};

export const messageRated = (positive, message) => {
  const rating = positive ? "Thumbs Up" : "Thumbs Down";
  analytics.track(
    "Message Rated",
    {
      rating,
      message
    },
    { context }
  );
};

export const feedbackSubmitted = (comment) => {
  analytics.track("Message Rated", { comment }, { context });
};

export const messageRegenerated = () => {
  analytics.track("Message Regenerated", {}, { context });
};

export const botChanged = (bot) => {
  analytics.track(
    "Chatbot Changed",
    {
      bot
    },
    { context }
  );
};

export const sessionRenamed = (session) => {
  analytics.track(
    "Session Renamed",
    {
      ...session
    },
    { context }
  );
};

export const sessionDeleted = (session) => {
  analytics.track(
    "Session Deleted",
    {
      ...session
    },
    { context }
  );
};

export const darkModeToggled = (darkMode) => {
  const mode = darkMode ? "Dark Mode" : "Light Mode";
  analytics.track(
    "Dark Mode Toggled",
    {
      mode
    },
    { context }
  );
};
